export function unsubscribeAll(...unsubscribers: (() => void)[]) {
  return () => unsubscribers.forEach((unsubscribe) => unsubscribe());
}
